import { useTranslation } from 'react-i18next'

import { Box } from '@/components/ui/box'
import { Container } from '@/components/ui/container'
import { Heading } from '@/components/ui/typography'
import { HEADER_HEIGHT } from '@/constants'
import { currentEnv } from '@/env/vars'
import useColorModeValue from '@/hooks/useColorModeValue'
import { useMobileDetection } from '@/hooks/useMobileDetection'

import { MobileAppWidget } from './components/mobileApp/MobileAppWidget'

export default function NotFound() {
    const { isMobile } = useMobileDetection()
    const isMobileLockEnabled = currentEnv.features.isEnabled('mobileLock')
    const { t } = useTranslation()

    return (
        <Container
            maxW="100%"
            h={[`calc(100% - ${HEADER_HEIGHT.mobile})`, `calc(100% - ${HEADER_HEIGHT.mobile})`, `calc(100% - ${HEADER_HEIGHT.desktop})`]}
            display="flex"
            flexDirection="column"
            flexGrow="1"
            padding="24px"
            backgroundColor={useColorModeValue('var(--chakra-colors-surface-light)', 'black')}
        >
            <Box pb="8">
                <Heading size="2xl" textAlign="center">
                    {t('global.pageNotFound.title')}
                </Heading>
            </Box>
            {isMobile && isMobileLockEnabled && (
                <Box flexGrow={1} justifyContent="center" alignContent="center">
                    <MobileAppWidget />
                </Box>
            )}
        </Container>
    )
}
